module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"filterQuantity10":"10","filterQuantity20":"20","filterQuantity50":"50","filterQuantityNull":"wszystkie","sortBySummaryDesc":"Średnia % malejąco","sortBySummaryAsc":"Średnia % rosnąco","sortByChangeDesc":"Zmiana % (do poprzedniego zakresu) malejąco","sortByChangeAsc":"Zmiana % (do poprzedniego zakresu) rosnąco"}}')
  delete Component.options._Ctor
}
